import { render, staticRenderFns } from "./hub-video-uploader.vue?vue&type=template&id=5147fbfc"
import script from "./hub-video-uploader.vue?vue&type=script&lang=js"
export * from "./hub-video-uploader.vue?vue&type=script&lang=js"
import style0 from "./hub-video-uploader.vue?vue&type=style&index=0&id=5147fbfc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports